import { businessDateOfTimestamp } from '../../dates/business-day.js';
import { calendarDateOfUtcInstant } from '../../dates/calendar-date.js';
/**
 * The ship day is a picked day stored at UTC midnight, so its UTC day is the day picked; the issue
 * time is an instant, which falls on its Pacific business day. Shipping on the issue day is fine.
 */
export function isShipDateBeforeIssued(dateShipped, dateIssued) {
    if (!dateIssued)
        return false;
    return calendarDateOfUtcInstant(dateShipped) < businessDateOfTimestamp(dateIssued);
}
//# sourceMappingURL=is-ship-date-before-issued.js.map